export const summaryHeaderContentSlots = ['box', 'heading', 'content'];
